import { render, staticRenderFns } from "./BaseContentCard.vue?vue&type=template&id=6001fc76&"
import script from "./BaseContentCard.vue?vue&type=script&lang=js&"
export * from "./BaseContentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports